import NavDrawer from './NavDrawer';
import { useEffect, useState } from 'react';
import { supabase } from './supabaseClient';
import { deployments } from './deploymentsData';

export default function DeploymentsPage() {
  const [user, setUser] = useState(null);
  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => setUser(session?.user ?? null));
  }, []);


  const COLORS = { feat: 'var(--cyan)', fix: 'var(--red)', improve: 'var(--gold)', legal: 'var(--purple)' };
  const RGBS = { feat: '--cyan-rgb', fix: '--red-rgb', improve: '--gold-rgb', legal: '--purple-rgb' };
  const LABELS = { feat: 'NEW FEATURE', fix: 'BUG FIX', improve: 'IMPROVEMENT', legal: 'LEGAL UPDATE' };
  const total = deployments.reduce((a, d) => a + d.entries.length, 0);

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', fontFamily: "'Share Tech Mono', monospace" }}>
      {user && <NavDrawer user={user} />}
      <div style={{ maxWidth: '760px', margin: '0 auto', padding: '40px 24px 80px' }}>
        <div style={{ paddingBottom: '28px', borderBottom: '1px solid var(--border)', marginBottom: '28px' }}>
          <a href="/" style={{ fontFamily: "'Orbitron', monospace", fontSize: '9px', color: 'var(--muted-2)', letterSpacing: '3px', textDecoration: 'none', display: 'inline-block', marginBottom: '16px' }}>← BACK TO APP</a>
          <div style={{ fontFamily: "'Orbitron', monospace", fontSize: '9px', color: 'var(--brand-gold)', letterSpacing: '4px', marginBottom: '8px' }}>COLLECTION KEEPER</div>
          <div style={{ fontFamily: "'Orbitron', monospace", fontSize: '28px', fontWeight: 900, color: 'var(--text-strong)', letterSpacing: '2px', marginBottom: '6px' }}>DEPLOYMENTS</div>
          <div style={{ fontSize: '11px', color: 'var(--muted-2)', letterSpacing: '2px' }}>// FEATURE RELEASES & BUG FIXES · NEWEST FIRST //</div>
        </div>
        <div style={{ display: 'flex', gap: '20px', marginBottom: '28px', flexWrap: 'wrap' }}>
          {[['feat','NEW FEATURE','var(--cyan)'],['improve','IMPROVEMENT','var(--gold)'],['fix','BUG FIX','var(--red)'],['legal','LEGAL UPDATE','var(--purple)']].map(([t,l,c]) => (
            <div key={t} style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
              <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: c, flexShrink: 0 }} />
              <span style={{ fontSize: '10px', color: c, letterSpacing: '1px' }}>{l}</span>
            </div>
          ))}
        </div>
        {deployments.map((deploy, di) => (
          <div key={di} style={{ marginBottom: '36px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '14px', marginBottom: '16px' }}>
              <div style={{ fontFamily: "'Orbitron', monospace", fontSize: '11px', letterSpacing: '3px', color: 'var(--cyan)', whiteSpace: 'nowrap' }}>{deploy.date.toUpperCase()}</div>
              <div style={{ flex: 1, height: '1px', background: 'var(--border)' }} />
              <div style={{ fontFamily: "'Orbitron', monospace", fontSize: '9px', color: 'var(--border-2)', background: 'var(--panel-deep)', border: '1px solid var(--border)', padding: '2px 8px', borderRadius: '2px' }}>{deploy.version}</div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {deploy.entries.map((entry, ei) => (
                <div key={ei} style={{ background: 'var(--panel-deep)', border: '1px solid var(--border)', borderRadius: '4px', overflow: 'hidden' }}>
                  <div style={{ padding: '10px 14px', borderBottom: '1px solid var(--panel-3)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div style={{ fontFamily: "'Orbitron', monospace", fontSize: '11px', letterSpacing: '2px', color: COLORS[entry.type] }}>{entry.title}</div>
                    <div style={{ fontSize: '8px', letterSpacing: '2px', padding: '2px 8px', borderRadius: '2px', color: COLORS[entry.type], background: `rgba(var(${RGBS[entry.type]}),0.08)`, border: `1px solid rgba(var(${RGBS[entry.type]}),0.2)`, whiteSpace: 'nowrap' }}>{LABELS[entry.type]}</div>
                  </div>
                  <div style={{ padding: '10px 14px', display: 'flex', flexDirection: 'column', gap: '7px' }}>
                    {entry.items.map((item, ii) => (
                      <div key={ii} style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', fontSize: '11px', color: 'var(--muted)', lineHeight: 1.6 }}>
                        <div style={{ width: '4px', height: '4px', borderRadius: '50%', background: COLORS[entry.type], marginTop: '6px', flexShrink: 0 }} />
                        {item}
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
        <div style={{ borderTop: '1px solid var(--border)', paddingTop: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ fontFamily: "'Orbitron', monospace", fontSize: '10px', color: 'var(--cyan)', letterSpacing: '2px' }}>© 2026 COLLECTIONKEEPER.ORG</div>
          <div style={{ fontSize: '10px', color: 'var(--border-2)', letterSpacing: '1px' }}>{total} DEPLOYMENTS · 2024-2026</div>
        </div>
      </div>
    </div>
  );
}
